<script>
import api from '@utils/api'

export default {
  name: 'ContactNew',
  props: {
    newContact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: true,
      loading: false,
      newItem: {
        firstName: null,
        lastName: null,
        middleName: null,
        sex: true,
        description: null,
        status: 1,
      },
      rules: {
        firstName: [x => !!x || this.$t('validation__is_required')],
        lastName: [x => !!x || this.$t('validation__is_required')],
      },
    }
  },
  computed: {
    status() {
      return this.$store.getters['data/getDictionary']('contactstatus')
      .map(item => {
        item.translatedStatus = this.$t(`contactstatus.${item.code}.name`)
        return item
      })
    },
    sex() {
      return [
        { code: true, name: this.$t('sex.true.name') },
        { code: false, name: this.$t('sex.false.name') },
      ]
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
      this.$refs.newContactForm.reset()
      this.newItem.sex = true
      this.newItem.status = 1
    },
    submit() {
      if (this.$refs.newContactForm.validate()) {
        this.loading = true
        api.createContact(this.newItem).then(response => {
          if (response) {
            this.$store.dispatch('data/updateDictionary', 'contact')
            this.$router.push(`contacts/${response.id}`)
          }
          this.loading = false
        })
      }
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="newContact"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <v-spacer />
        <div class="headline">{{ $t('titles__new_contact') }}</div>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex
              xs12
              class="text-xs-center"
            >
              <v-form
                ref="newContactForm"
                v-model="valid"
                lazy-validation
              >
                <v-text-field
                  :label="$t('label__first_name')"
                  v-model="newItem.firstName"
                  :rules="rules.firstName"
                  name="firstName"
                  autocomplete="off"
                  required
                />
                <v-text-field
                  :label="$t('label__last_name')"
                  v-model="newItem.lastName"
                  name="lastName"
                  autocomplete="off"
                  required=""
                />
                <v-text-field
                  :label="$t('label__middle_name')"
                  v-model="newItem.middleName"
                  name="middleName"
                  autocomplete="off"
                />
                <v-select
                  :items="sex"
                  :label="$t('label__sex')"
                  v-model="newItem.sex"
                  item-text="name"
                  item-value="code"
                />
                <v-text-field
                  :label="$t('label__description')"
                  v-model="newItem.description"
                  :rows="2"
                  name="description"
                  autocomplete="off"
                  multi-line
                />
                <v-select
                  :items="status"
                  :label="$t('label__status')"
                  :rules="rules.status"
                  v-model="newItem.status"
                  item-text="translatedStatus"
                  item-value="code"
                  required
                />
              </v-form>
            </v-flex>
            <small>* {{ $t('label__requier_small_text') }}</small>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="loading"
          color="secondary"
          @click="closeModal">{{ $t('buttons__close') }}</v-btn>
        <v-btn
          :loading="loading"
          :disabled="loading"
          color="primary"
          @click="submit">{{ $t('buttons__create') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
</style>
